import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import fiberFoundSuccessDesktop from './Animation/Seccessful_Desctop.json';
import fiberFoundSuccessMobile from './Animation/Seccessful_Mobile.json';
import './internetFoundFiberSuccess.scss';

const SUBTITLE_SUFFIX = 'אפשר לעוף עם האינטרנט הכי מהיר בישראל!';

const InternetFoundFiberSuccess = (props) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      props.onValid({ valid: true });
    }, 3000);
    gtag4({
      event: `${props.saleType}_Step3_SivimExistsPage`,
      step: '3',
      action: 'SivimExistsPage',
      funnel_name: 'Sivim_Exists',
    });
    return () => clearTimeout(timer);
  }, []);

  const cmsText = props.textsaleType?.trim() || 'יש אצלך סיבים';

  return (
    <div className='internet-found-fiber-success'>
      <div className='internet-found-fiber-success__content'>
        <h1 className='internet-found-fiber-success__title'>מצאנו!</h1>
        <p className='internet-found-fiber-success__subtitle'>
          {cmsText}, {SUBTITLE_SUFFIX} 
        </p>
      </div>
      <div className={`internet-found-fiber-success__illustration${isMobile ? ' is-mobile' : ''}`}>
        <ThemedLottie
          animationData={isMobile ? fiberFoundSuccessMobile : fiberFoundSuccessDesktop}
          loop={false}
          autoplay={true}
          rendererSettings={{
            preserveAspectRatio: isMobile ? 'xMidYMid slice' : 'xMidYMid meet',
          }}
        />
      </div>
    </div>
  );
};

export default InternetFoundFiberSuccess;
